import React from "react";
// import RSSAppCarousel from "../Home/RSSAppCarousel";
import ImageBoardWidget from "../ArtEvents/ImgWidget";
// import MagazineWidget from "../ArtEvents/MagazineWidget";
import { Card } from "reactstrap";

export default function ArtEvents() {
  return (
    <>
      <Card className="mt-5 pt-5 font-light">
        <h3 className="text-center ">
          Canvas Magazine - Contemporary & Modern Art of the Middle East,
          <br />
          Painting, Sculpture, Writing
        </h3>
        <iframe
          width="1300"
          height="2450"
          src="https://rss.app/embed/v1/magazine/rtv2RpON1bJ3jLbw"
          frameborder="0"
        ></iframe>
      </Card>

      <Card className="mt-5 pt-5 font-light">
        <iframe
          width="1295"
          height="520"
          src="https://rss.app/embed/v1/carousel/V6CavdTJpJMfK8iP"
          frameborder="0"
        ></iframe>
      </Card>
      <Card className="mt-5">
        {/* <div> <RSSAppCarousel /> </div> */}
        <div className="mt-5">
          <ImageBoardWidget />
        </div>
        {/* <div>
          <MagazineWidget />
        </div> */}
      </Card>
    </>
  );
}
